module.exports = __webpack_public_path__ + "static/company2-f79b211d3222fdcd3b1350a77a714889.png";